var map = {
	"./activity_g.png": 669,
	"./activity_r.png": 670,
	"./activity_y.png": 671,
	"./age_g.png": 672,
	"./age_r.png": 673,
	"./age_y.png": 674,
	"./animal_g.png": 675,
	"./animal_r.png": 676,
	"./animal_y.png": 677,
	"./avatar_doencas_cronicas.png": 678,
	"./avatar_front_shadow.png": 679,
	"./avatar_longevidade.png": 680,
	"./avatar_riscos.png": 371,
	"./avatar_saude_coracao.png": 681,
	"./avatar_saude_preventiva.png": 682,
	"./avatar_side_shadow.png": 683,
	"./b_g.png": 372,
	"./b_r.png": 373,
	"./b_y.png": 374,
	"./botao.png": 684,
	"./caretaker_g.png": 685,
	"./caretaker_r.png": 686,
	"./caretaker_y.png": 687,
	"./circunference_g.png": 688,
	"./circunference_r.png": 689,
	"./clt_g.png": 690,
	"./clt_r.png": 691,
	"./clt_y.png": 692,
	"./creatinina_g.png": 693,
	"./creatinina_r.png": 694,
	"./daily_activity_g.png": 695,
	"./daily_activity_r.png": 696,
	"./daily_activity_y.png": 697,
	"./diabetes_g.png": 698,
	"./diabetes_r.png": 699,
	"./diabetes_y.png": 700,
	"./diseases_g.png": 701,
	"./diseases_r.png": 702,
	"./drink_g.png": 703,
	"./drink_r.png": 704,
	"./drink_y.png": 705,
	"./familiar_disease_g.png": 706,
	"./familiar_disease_r.png": 707,
	"./family_g.png": 708,
	"./family_r.png": 709,
	"./family_y.png": 710,
	"./fruits_g.png": 711,
	"./fruits_r.png": 712,
	"./fruits_y.png": 713,
	"./gender_g.png": 714,
	"./gender_r.png": 715,
	"./gender_y.png": 716,
	"./gli_g.png": 717,
	"./gli_r.png": 718,
	"./gli_y.png": 719,
	"./glucose_g.png": 720,
	"./glucose_r.png": 721,
	"./glucose_y.png": 722,
	"./hdl_g.png": 723,
	"./hdl_r.png": 724,
	"./hdl_y.png": 725,
	"./health_g.png": 726,
	"./health_r.png": 727,
	"./health_y.png": 728,
	"./heart_disease_g.png": 729,
	"./heart_disease_r.png": 730,
	"./heart_disease_y.png": 731,
	"./hemoglobin_g.png": 732,
	"./hemoglobin_r.png": 733,
	"./hemoglobin_y.png": 734,
	"./home_g.png": 735,
	"./home_r.png": 736,
	"./home_y.png": 737,
	"./hospitalized_g.png": 738,
	"./hospitalized_r.png": 739,
	"./hypertension_g.png": 740,
	"./hypertension_r.png": 741,
	"./hypertension_y.png": 742,
	"./icon_green.png": 743,
	"./icon_red.png": 744,
	"./icon_yellow.png": 745,
	"./imc_g.png": 746,
	"./imc_r.png": 747,
	"./imc_y.png": 748,
	"./ldl_g.png": 749,
	"./ldl_r.png": 750,
	"./ldl_y.png": 751,
	"./limited_activity_g.png": 752,
	"./limited_activity_r.png": 753,
	"./limited_activity_y.png": 754,
	"./medic_g.png": 755,
	"./medic_r.png": 756,
	"./pregnant_g.png": 757,
	"./pressure_g.png": 758,
	"./pressure_r.png": 759,
	"./pressure_y.png": 760,
	"./psychologic_g.png": 761,
	"./psychologic_r.png": 762,
	"./sleep_g.png": 763,
	"./sleep_r.png": 764,
	"./smoke_g.png": 765,
	"./smoke_r.png": 766,
	"./smoke_y.png": 767,
	"./tfg_g.png": 768,
	"./tfg_r.png": 769,
	"./tfg_y.png": 770,
	"./tri_g.png": 771,
	"./tri_r.png": 772,
	"./tri_y.png": 773,
	"./walk_support_g.png": 774,
	"./walk_support_r.png": 775,
	"./walk_support_y.png": 776
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 60;


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks ^\.\/.*\.png$
// module id = 60
// module chunks = 1